import React from 'react';
import styled from 'styled-components';
import { mediaQuery } from '../../../../theme';
import { useAddress } from '../../useAddress';
import { colors } from '../../../../theme/color';

export const AddressBookInput: React.FC = () => {
  const address = useAddress();

  if (!address) {
    return null;
  }

  return (
    <AddressBar>
      <Address>
        <div>
          <b>
            <span translate="no">{address.streetAddress}</span> {address.apartmentNumber}
          </b>
        </div>
        <City>
          <span translate="no">{address.city}</span>
        </City>
      </Address>
      <DropdownButton>
        <DropdownButtonArrow />
      </DropdownButton>
    </AddressBar>
  );
};

const Address = styled.div`
  color: black;
  margin: 1rem;
  line-height: 1;
`;

const City = styled.div`
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600;
  padding-top: 2px;
  text-align: left;
`;

const AddressBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  border: 1px solid ${colors.borderDefault};
  border-radius: ${({ theme }) => theme.sizes?.borderRadius.default};
  height: 3.625rem;
  width: 100%;
  position: relative;

  &:hover {
    cursor: pointer;
  }

  @media ${mediaQuery.medium} {
    margin-bottom: 16px;
  }
`;

const DropdownButton = styled.div`
  background: ${colors.green.lighter(50)};
  width: 48px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-right-radius: ${({ theme }) => theme.sizes?.borderRadius.default};
  border-bottom-right-radius: ${({ theme }) => theme.sizes?.borderRadius.default};
`;

const DropdownButtonArrow = styled.div`
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 11px solid ${colors.green.darker(40)};
`;
